import { Delivery } from "redux/constants/Delivery";

const initState = {
  data: [],
  loading: false,
};

const delivery = (state = initState, action) => {
  switch (action.type) {
    case Delivery.LOADING_DELIVERY_LIST:
      return {
        ...state,
        loading: action.payload,
      };
    case Delivery.GET_DELIVERY_LIST:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default delivery;